import React from 'react';
import Scrollbar from 'react-smooth-scrollbar';
import classNames from 'classnames';
// import PropTypes from 'prop-types';
import SidebarContent from './SidebarContent';
// import { SidebarProps } from '../../../shared/prop-types/ReducerProps';

const Sidebar = ({
  changeToDark,
  changeToLight,
  changeMobileSidebarVisibility,
  sidebar,
  data,
}) => {
  const sidebarClass = classNames({
    sidebar: true,
  });

  return (
    <div className={sidebarClass}>
      <button
        type="button"
        className="sidebar__back"
        onClick={changeMobileSidebarVisibility}
      />
      <Scrollbar className="sidebar__scroll scroll">
        <div className="sidebar__wrapper sidebar__wrapper--desktop">
          <SidebarContent
            onClick={() => {}}
            // changeToDark={changeToDark}
            // changeToLight={changeToLight}
            data={data}
          />
        </div>
        <div className="sidebar__wrapper sidebar__wrapper--mobile">
          <SidebarContent
            onClick={changeMobileSidebarVisibility}
            // changeToDark={changeToDark}
            // changeToLight={changeToLight}
            data={data}
          />
        </div>
      </Scrollbar>
    </div>
  );
};

// Sidebar.propTypes = {
//   sidebar: SidebarProps.isRequired,
//   changeToDark: PropTypes.func.isRequired,
//   changeToLight: PropTypes.func.isRequired,
//   changeMobileSidebarVisibility: PropTypes.func.isRequired,
// };

export default Sidebar;
